import { fetchApi } from '@/config/axiosSetting';
import { AddDamagedVehicleAdjusterQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedVehicleAdjuster/addDamagedVehicleAdjusterQuery.type';
import { createImagesFlowPostData } from '@/modules/adjusterReportModules/IncidentParticipants/utils/createImagesFlowPostData';

export const addDamagedVehicleAdjusterFunction = (
  params: AddDamagedVehicleAdjusterQueryParamsType,
) => {
  const data = createImagesFlowPostData().createPostFormData({
    damagedImages: params.damaged_images,
    initialImages: params.initial_images,
    vehicleType: params.vehicleType,
  });

  const url = () => {
    switch (params.participantRoleType) {
      case 'culprit':
      case 'damaged':
        return `property/reports/${params?.id}/accident_users/${params?.participantRoleType}/adjuster/vehicle/`;
      case 'body':
        return `body/reports/${params?.id}/images/adjuster/vehicle/`;

      case 'initial':
        return `initial/reports/${params.id}/images/adjuster/vehicle/`;
      default:
        return `property/reports/${params?.id}/accident_users/${params?.participantRoleType}/adjuster/vehicle/`;
    }
  };
  return fetchApi.post(url(), data, {
    params: {
      id: params?.id,
      damaged_id:
        params.participantRoleType === 'damaged'
          ? params?.damaged_id
          : undefined,
    },
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      const progress = progressEvent.total
        ? (progressEvent.loaded / progressEvent.total) * 100
        : 0;
      if (params.onProgress) {
        params.onProgress(progress, progressEvent.loaded);
      }
    },
    signal: params.signal,
  });
};
